export default __webpack_public_path__ + "static/media/IMG_7261 copie copy.f2eab1ac.JPG";